import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'rapid-rapid-angular',
  template: `
    <p>
      rapid-angular works!
    </p>
  `,
  styles: []
})
export class RapidAngularComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
